import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledExportRow = styled(Flexbox)(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 3}px ${spacing * 4}px;
        border-bottom: 1px solid ${palette.neutral[100]};
    `
)

/** Leading status indicator: a small, fixed-size icon aligned with the row's first line. */
export const StyledStatusIcon = styled.span(
    ({theme: {spacing}}) => css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        margin-top: ${spacing / 2}px;
    `
)

export const StyledExportMetaLine = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        flex-wrap: wrap;
        column-gap: ${spacing * 3}px;
        row-gap: ${spacing}px;
    `
)

/** Clickable, underlined file name that downloads a ready export. */
export const StyledDownloadName = styled.button(
    ({theme: {palette}}) => css`
        border: none;
        background: none;
        padding: 0;
        cursor: pointer;
        text-align: left;
        font-size: 13px;
        font-weight: 500;
        color: ${palette.neutral[900]};
        text-decoration: underline;

        &:hover {
            color: ${palette.primary[600]};
        }

        &:disabled {
            cursor: default;
            opacity: 0.6;
        }
    `
)

/** Wrapper that renders the horizontal dots icon as a vertical (kebab) menu glyph. */
export const StyledKebabIcon = styled.span(
    () => css`
        display: inline-flex;
        transform: rotate(90deg);
    `
)

/** Trigger button that toggles the filters/columns accordion, showing the count summary. */
export const StyledMetaAccordionTrigger = styled.button(
    ({theme: {spacing, palette, transition}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing}px;
        width: 100%;
        padding: 0;
        border: none;
        background: none;
        cursor: pointer;
        color: ${palette.neutral[600]};
        font-size: 12px;
        font-weight: 500;

        &:hover {
            color: ${palette.neutral[900]};
        }

        svg {
            width: 14px;
            height: 14px;
            flex-shrink: 0;
            transition: transform ${transition};
        }

        &[aria-expanded='true'] svg {
            transform: rotate(90deg);
        }
    `
)

/** Collapsible body holding the full filters and columns detail lines. */
export const StyledMetaAccordionContent = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        flex-direction: column;
        gap: ${spacing}px;
        padding-top: ${spacing}px;
    `
)
